/**
 * Item claim error codes
 */
const ItemClaimErrorCodes = {
	Unmappable: 1,
	ItemDataInvalid: 2,
	ItemNotFound: 4,
	ItemUnfulfilable: 8,
	ClaimPriceMismatch: 16,
	ClaimMaxQtyExceeded: 32,
	ClaimCriteriaValidation: 64
};


/**
 * Get the user-facing message for an error code's value.
 *
 * @param {Integer} code
 * @return {String}
 */
export const getMessage = code => {
	switch (code) {
		case ItemClaimErrorCodes.ItemNotFound:
			return "The item is no longer available.";
		case ItemClaimErrorCodes.ItemUnfulfilable:
			return "The item is no longer available or has sold out.";
		case ItemClaimErrorCodes.ClaimPriceMismatch:
			return "The item's price has changed.";
		case ItemClaimErrorCodes.ClaimMaxQtyExceeded:
			return "The item's maximum quantity limit has changed.";
		case ItemClaimErrorCodes.ClaimCriteriaValidation:
			return "Please check any purchase restrictions displayed.";
		default:
			return `Internal item claim error (E${code}).`;
	}
};


/**
 * Item claim error code class.
 *
 * @package HOPS
 * @subpackage Orders
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
export class ItemClaimErrorCode {

	/**
	 * Constructor.
	 *
	 * @param {Integer} code Error code value
	 * @return {self}
	 */
	constructor(code) {

		/**
		 * Error code value
		 *
		 * @type {Integer}
		 */
		this.code = code;

	}


	/**
	 * Get the error message.
	 *
	 * @return {String}
	 */
	getMessage() {
		return getMessage(this.code);
	}

}

export default ItemClaimErrorCodes;
